import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  description: {
    defaultMessage:
      'Custom Packages will be available to select as a package type for any shipment and will automatically update the shipment dimensions with the custom package dimensions.',
    id: 'WfyWuB',
    description: 'Custom package modal message',
  },
  'header-edit': {
    defaultMessage: 'Edit Custom Package',
    id: 'ZlVSBF',
    description: 'Custom package modal edit package header',
  },
  'header-add': {
    defaultMessage: 'New Custom Package',
    id: 'n07Y4E',
    description: 'Custom package modal new package header',
  },
  save: {
    defaultMessage: 'Save',
    id: '+gIXhZ',
    description: 'Custom package modal save button label',
  },
  cancel: {
    defaultMessage: 'Cancel',
    id: 'dSwGhM',
    description: 'Custom package modal cancel button label',
  },
});

export const formMessages = defineMessages({
  'form-label-name': {
    defaultMessage: 'Name',
    id: 'Bt87Im',
    description: 'Custom package modal name input label',
  },
  'form-label-dimensions': {
    defaultMessage: 'Size',
    id: '8khCc4',
    description: 'Custom package modal size input label',
  },
  'form-label-tare-weight': {
    defaultMessage: 'Tare Weight',
    id: '+axsBl',
    description: 'Custom package modal tare weight input label',
  },
  'form-label-max-weight': {
    defaultMessage: 'Max Weight',
    id: '27i/Wt',
    description: 'Custom package modal max weight input label',
  },
  'form-helper-tare-weight': {
    defaultMessage: 'Weight of the empty package',
    id: 'f9H68E',
    description: 'Custom package modal tare weight helper text',
  },
  'form-helper-max-weight': {
    defaultMessage: 'Maximum weight capacity',
    id: 'rdC+bq',
    description: 'Custom package modal max weight helper text',
  },
  'form-placeholder-example': {
    defaultMessage: 'e.g. {value}',
    id: 'mB+ziq',
    description: 'Custom package modal placeholder showing an example numeric value for a weight input',
  },
  'form-validation-size': {
    defaultMessage: 'Length, width and height must be greater than 0',
    id: 'ZDmSca',
    description: 'Custom package modal validation text shown when any package dimension is missing or zero',
  },
  'form-validation-max-weight': {
    defaultMessage: 'Max weight is required and must be greater than 0',
    id: '29KsMS',
    description: 'Custom package modal validation text shown when max weight is missing or not greater than zero',
  },
});
